/**
* Slide Scroll JS
* -----------------------------------------------------------------------------
*
* All the JS for the Slide Scroll component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';

( function( app ) {
  const COMPONENT = {
    className: 'slide-scroll',
    selector: function() {
      return '.' + this.className;
    },
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      const scrollSection = document.querySelector( '.scroll-section' );
      const scrollWrapper = document.querySelector( '.scroll-wrapper' );
      const rightContent = document.querySelector( '.right-content' );

      function updateScroll() {
        let scrollDistance = scrollWrapper.scrollWidth - scrollSection.clientWidth + 55;

        if ( window.innerWidth < 768 ) {
          scrollDistance = Math.max( scrollDistance, rightContent.offsetWidth * 0.6 + 50 );
        }

        if ( window.innerWidth >= 1024 ) {
          gsap.to( scrollWrapper, {
            x: () => -scrollDistance,
            ease: 'power1.out',
            scrollTrigger: {
              trigger: scrollSection,
              pin: true,
              scrub: 0.3,
              pinSpacing: true,
              // anticipatePin: 0,
              start: 'top top',
              end: () => `+=${scrollDistance * 0.85}`,
            },
          } );
        }
      }

      updateScroll();

      window.addEventListener( 'resize', () => {
        ScrollTrigger.refresh();
        updateScroll();
      } );
    },
    finalize: function() {},
  };

  app.registerComponent( 'slide-scroll', COMPONENT );
} )( app );
